/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { GridCustomizedPopupEditor } from '@bingads-webui-campaign/grid-customized-popup-editor';
import { CampaignLanguageInlineEditor } from '@bingads-webui-campaign/campaigns-language';
import { inlineEditSave } from '@bingads-webui-campaign/summary-grid-helper';
import { AdGroup } from '@bingads-webui-campaign/campaign-ui-schemas';
import appConfig from '@bingads-webui-component-legacy/config/index';
import jsData from '@bingads-webui-component-legacy/js-data-campaign/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import template from './campaign-languages-template.pug';

const permissions = appConfig.get('Permissions');

export function getLanguageSetForSelector() {
  let languagesSet = _.without(_.clone(AdGroup.properties.Language.enum), 'None');
  const {
    IsSimplifiedChineseLanguageEnabledInMultipleLanguage,
    IsAdsGlobalizationPhase1Enabled,
    IsAdsGlobalizationPhase2Enabled,
    IsAdsGlobalizationPhase2JapanEnabled,
    IsAdsGlobalizationPhase6Enabled,
    IsDomesticSimplifiedChineseEnabled,
    IsAdsGlobalizationPhase9Enabled,
    IsAdsGlobalizationPhase9VIEnabled,
  } = permissions;

  if (!IsSimplifiedChineseLanguageEnabledInMultipleLanguage) {
    languagesSet = _.without(languagesSet, 'SimplifiedChinese');
  }

  if (!IsAdsGlobalizationPhase1Enabled) {
    languagesSet = _.without(languagesSet, 'Greek', 'Polish', 'Bulgarian', 'Croatian', 'Czech', 'Estonian', 'Hungarian', 'Latvian', 'Lithuanian', 'Maltese', 'Romanian', 'Slovak', 'Slovenian');
  }

  if (!IsAdsGlobalizationPhase2Enabled) {
    languagesSet = _.without(languagesSet, 'Turkish', 'Serbian', 'Bosnian', 'Albanian', 'Macedonian', 'Icelandic');
  }

  if (!IsAdsGlobalizationPhase6Enabled) {
    languagesSet = _.without(languagesSet, 'Hebrew', 'Arabic', 'Russian');
  }

  if (!IsAdsGlobalizationPhase2JapanEnabled) {
    languagesSet = _.without(languagesSet, 'Japanese');
  }

  if (!IsAdsGlobalizationPhase9Enabled) {
    languagesSet = _.without(languagesSet, 'Hindi', 'Malay', 'Thai', 'Indonesian', 'Tagalog');
  }

  if (!IsAdsGlobalizationPhase9VIEnabled) {
    languagesSet = _.without(languagesSet, 'Vietnamese');
  }

  if (IsDomesticSimplifiedChineseEnabled) {
    languagesSet = ['SimplifiedChinese'];
  }

  return languagesSet.sort();
}


export class CampaignLanguagesColumn extends CampaignuiBaseColumn {
  constructor({ i18n, view, isForVNext }) {
    const title = i18n.getString('ColumnName_Languages');
    super({
      name: 'Languages',
      property: ['Languages', 'CampaignType'],
      title,
      editable: true,
      type: 'string',
      helpId: 'pop_BA_CampaignCreate_Settings_LanguageTargeting',
      enableEdit: item => item.CampaignType === 'Default',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.i18n = i18n;
    this.view = view;
    this.isForVNext = isForVNext;
  }

  onPrompt({ position, item, newPosition }) {
    const languageInlineEditorView = new CampaignLanguageInlineEditor({
      item,
      i18n: this.i18n,
      languages: getLanguageSetForSelector(),
    });

    languageInlineEditorView.on('save', ({ SelectedLanguages }) => {
      const updatedItem = _.defaults({
        Languages: SelectedLanguages,
      }, item);

      return inlineEditSave({
        id: item.Id,
        fieldName: 'Languages',
        updatedItem,
      }, {
        view: this.view,
        resource: jsData.Campaign,
        i18n: this.i18n,
        i18nErrors,
        editorView: languageInlineEditorView,
        editorViewCallbackAfterUpdate: () => {
          languageInlineEditorView.trigger('close');
        },
        customBlockerTarget: this.isForVNext ? '.campaigns-page' : null,
      });
    });
    const groupClass = `grid-group-${_.result(this.config, 'group', 'other')}`;
    const editorView = new GridCustomizedPopupEditor({
      editorView: languageInlineEditorView.render(),
      cellPosition: this.isForVNext ? newPosition : position,
      renderBelow: false,
      className: `grid-popupeditor ${groupClass}`,
      parentContainerSelector: this.isForVNext ? '.grid-and-disclaim-container' : null,
    });

    return editorView.render();
  }

  pickProperty(item) {
    return {
      Languages: item.Languages,
    };
  }

  template({ value }) {
    return template({
      Languages: value.Languages,
      i18n: this.i18n,
    });
  }
}
